var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0824 9.47852C11.1689 9.47844 11.2534 9.45274 11.3253 9.40466C11.3972 9.35658 11.4532 9.28828 11.4862 9.20839C11.5193 9.12849 11.528 9.04059 11.5111 8.95577C11.4943 8.87095 11.4527 8.79303 11.3916 8.73185L7.30825 4.64852C7.22622 4.56659 7.11502 4.52057 6.99908 4.52057C6.88314 4.52057 6.77195 4.56659 6.68992 4.64852L2.60658 8.73185C2.54547 8.79303 2.50387 8.87095 2.48702 8.95577C2.47017 9.04059 2.47883 9.12849 2.51192 9.20839C2.545 9.28828 2.60101 9.35658 2.67289 9.40466C2.74476 9.45274 2.82928 9.47844 2.91575 9.47852L11.0824 9.47852Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.5f1def498f115c48ac365b22397d2c05.svg";
export { ForwardRef as ReactComponent };